import { FrameName } from "../config";
import TileEntity from "../TileEntity";

type LighthouseFrameNames =
	| FrameName.LIGHTHOUSE
	| FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE;

class ShallowSeaRocksLighthouseBuildingTileEntity extends TileEntity {
	public static readonly frameName: LighthouseFrameNames =
		FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE;
}

export default ShallowSeaRocksLighthouseBuildingTileEntity;
